export default "__VITE_ASSET__55711a8e__"